/* eslint-disable @typescript-eslint/no-explicit-any */
import { Module, Commit } from "vuex";

// Define the interface for the object
type Item = {
  id: number;
};

type MasterDataState = {
  [key: string]: Item[];
};

const initialState: MasterDataState = {};

export const masterData: Module<MasterDataState, any> = {
  state: initialState,
  mutations: {
    storeMasterData(
      state: MasterDataState,
      newData: { [key: string]: Item[] }
    ) {
      Object.keys(newData).forEach((key) => {
        state[key] = newData[key];
      });
    },
  },
  actions: {
    fetchMasterData(
      { commit }: { commit: Commit },
      newData: { [key: string]: Item[] }
    ) {
      // Commit mutation with newData as payload
      commit("storeMasterData", newData);
    },
  },
  getters: {},
};

// Item: Type for individual items in the array
// MasterDataState: State object type
// newData: New data to store in the state
